import { Component, Inject, OnInit } from '@angular/core';
import {
    DeviceGetCurrentInfoResponse,
    RemoteTvCmdService,
    TimerConfTimerList,
} from '../../../../services/remote-Tv-Cmd/remote-tv-cmd.service';
import { AlertService } from '../../../../services/alert/alert.service';
import {
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatDialog,
} from '@angular/material/dialog';
import {
    UntypedFormArray,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
} from '@angular/forms';
import { ConfirmationDialogComponent } from '../../../../helpers/dialog/confirmation-dialog/confirmation-dialog.component';
import { FaceTimeWorkService } from '../../../../services/face-Time-Work/face-time-work.service';
import { FaceTimeWork } from '../../../../services/face-Time-Work/faceTimeWork.model';

@Component({
    selector: 'app-screen-parameters',
    templateUrl: './screen-parameters.component.html',
    styleUrls: ['./screen-parameters.component.scss'],
})
export class ScreenParametersComponent implements OnInit {
    public isReadOnly: boolean = false;

    // MARK: CONSTRUCTOR
    constructor(
        public remoteTvCmd$: RemoteTvCmdService,
        public faceTimeWork$: FaceTimeWorkService,
        public alert$: AlertService,
        public dialogRef: MatDialogRef<ScreenParametersComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            faceId: number;
            screenName: string;
            readOnly: boolean;
        },
        private fb: UntypedFormBuilder,
        public dialog: MatDialog
    ) { }

    /**
     * Données de l'écran récupérée par API
     */
    public screenTimers: TimerConfTimerList[] = [];
    /**
     * Données de l'écran au format insxcrit en V2
     */
    public faceTimeWorks: FaceTimeWork[] = [];
    /**
     * FormGroup global des infos
     */
    public timeForm: UntypedFormGroup;
    public daysOfWeek = [
        { value: 127, viewValue: 'Semaine' },
        { value: 96, viewValue: 'Week-End' },
        { value: 1, viewValue: 'Lundi' },
        { value: 2, viewValue: 'Mardi' },
        { value: 4, viewValue: 'Mercredi' },
        { value: 8, viewValue: 'Jeudi' },
        { value: 16, viewValue: 'Vendredi' },
        { value: 32, viewValue: 'Samedi' },
        { value: 64, viewValue: 'Dimanche' },
    ];
    /**
     * Loader du tableau des horaires
     */
    public isTimersLoaded: boolean = false;
    /**
     * Mode de sélection simple des dates :
     *
     * - StartDay = EndDay, on ne sélectionne qu'une seule fois les jours qui compte pour l'ouverture `ET` la fermeture
     */
    public isDateSimpleMode: boolean = true;

    ngOnInit(): void {

        this.isReadOnly = this.data.readOnly === true;
        this.getCurrentTimers_V2();

        // this.getCurrentTimers_MagicInfo();
    }

    /**
     * Transfère les informations de screenTimers dans les FormControls associés
     */
    private screenTimersToFormControl() {
        //Retire les timers désactivés
        this.screenTimers = this.screenTimers.filter(
            (timer: TimerConfTimerList) => {
                return (
                    timer.timerOnStatus === '1' || timer.timerOffStatus === '1'
                );
            }
        );

        //Créé le FormGroup global
        this.timeForm = this.fb.group({
            timers: new UntypedFormArray([]),
        });

        //Pour chaque screenTimers, Ajoute un formGroup initialisé avec la valeur du screenTimer
        this.screenTimers.forEach((screenTime: TimerConfTimerList) => {
            const startDayForm = new UntypedFormControl(
                this.getDayFromTimerConfTimerList(true, screenTime)
            );

            const endDayForm = new UntypedFormControl(
                this.getDayFromTimerConfTimerList(false, screenTime)
            );

            if (this.isReadOnly) {
                startDayForm.disable();
                endDayForm.disable();
            }

            this.timersFormArray.push(
                this.fb.group({
                    startDay: startDayForm,
                    endDay: endDayForm,
                    start: new UntypedFormControl(
                        this.getTimeFromTimerConfTimerList(screenTime, true)
                    ),
                    end: new UntypedFormControl(
                        this.getTimeFromTimerConfTimerList(screenTime, false)
                    ),
                })
            );
        });

        this.isTimersLoaded = true;
    }

    /**
     * Récupère l'index des jours à partir des infos de MagicInfo
     * @param timer Timer MagiciInfo dont on souhaite récupérer le(s) jour(s)
     * @returns le tableau avec les index des jours
     */
    private getDayFromTimerConfTimerList(
        isStart: boolean,
        timer: TimerConfTimerList
    ): number[] {
        //Jour de début
        if (isStart) {
            //Timer actif ?
            if (timer.timerOnStatus === '1') {
                //En fonction du timer repeat, instancie la valeur du FormControl
                switch (timer.timerRepeat) {
                    case '1':
                        return [127];
                    case '2':
                        return [1, 2, 4, 8, 16];
                    case '3':
                        return [1, 2, 4, 8, 16, 32];
                    case '4':
                        return [96];
                    default:
                        if (timer.timerManualWeekday === '0000000') {
                            return [];
                        } else {
                            let response: number[] = [];
                            let matchIndex: number[] = this.getMatchIndexes(
                                timer.timerManualWeekday,
                                '1'
                            );

                            matchIndex.forEach((index) => {
                                response.push(Math.pow(2, index));
                            });

                            return response;
                        }
                }
            } else {
                //Timer Off
                return [];
            }
            //End
        } else if (timer.timerOffStatus === '1') {
            switch (timer.timerOffRepeat) {
                case '1':
                    return [127];
                case '2':
                    return [1, 2, 4, 8, 16];
                case '3':
                    return [1, 2, 4, 8, 16, 32];
                case '4':
                    return [96];
                default:
                    if (timer.timerOffManualWeekday === '0000000') {
                        return [];
                    } else {
                        let response: number[] = [];
                        let matchIndex: number[] = this.getMatchIndexes(
                            timer.timerOffManualWeekday,
                            '1'
                        );

                        matchIndex.forEach((index) => {
                            response.push(Math.pow(2, index));
                        });

                        return response;
                    }
            }
        } else {
            return [];
        }
    }

    /**
     * Récupère tous les index dans un string, indexs décalés car DIM/LUN... et non LUN/MAR/...
     * - [Volé ici - stackoverflow.com](https://stackoverflow.com/questions/16897772/looping-through-string-to-find-multiple-indexes)
     * @param str string à analyser
     * @param toMatch element(s) à trouver
     * @returns number[]
     */
    private getMatchIndexes(str: string, toMatch: string): number[] {
        let indexMatches: number[] = [],
            match: number,
            i: number = 0;

        while ((match = str.indexOf(toMatch, i)) > -1) {
            if (match === 0) {
                indexMatches.push(str.length - 1);
            } else {
                indexMatches.push(match - 1);
            }
            i = match + toMatch.length;
        }

        return indexMatches;
    }

    /**
     *
     * @param isStart true = start / false = end
     * @param timer Timer MagiciInfo dont on souhaite récupérer les horaires
     * @returns l'horaire correspondante
     */
    private getTimeFromTimerConfTimerList(
        timer: TimerConfTimerList,
        isStart: boolean = false
    ) {
        if (isStart) {
            //Start
            if (timer.timerOnStatus === '1') {
                if (timer.timerOnAmpm === '1') {
                    return `${timer.timerOnH.length !== 2
                        ? '0' + timer.timerOnH
                        : timer.timerOnH
                        }:${timer.timerOnM}`;
                } else {
                    timer.timerOnAmpm = '1';
                    return `${parseInt(timer.timerOnH) + 12}:${timer.timerOnM}`;
                }
            } else {
                return null;
            }
        } else if (timer.timerOffStatus === '1') {
            if (timer.timerOffAmpm === '1') {
                return `${timer.timerOffH.length !== 2
                    ? '0' + timer.timerOffH
                    : timer.timerOffH
                    }:${timer.timerOffM}`;
            } else {
                timer.timerOffAmpm = '1';
                return `${parseInt(timer.timerOffH) + 12}:${timer.timerOffM}`;
            }
        } else {
            return null;
        }
    }

    get timersFormArray(): UntypedFormArray {
        return this.timeForm.get('timers') as UntypedFormArray;
    }

    /**
     * @deprecated fonction de test
     */
    test() {
        this.remoteTvCmd$.getDeviceInfos(this.data.faceId).subscribe((res) => {
            console.log(res);
        });

        this.remoteTvCmd$
            .getDevicePowerStatus(this.data.faceId)
            .subscribe((isPowerOn: boolean) => {
                console.log(isPowerOn);
            });
    }

    /**
     * Ajoute un nouveau Timer dans la liste
     */
    addNewTimer() {
        if (this.screenTimers.length < 7) {
            this.screenTimers.push(new TimerConfTimerList());

            this.timersFormArray.push(
                this.fb.group({
                    startDay: new UntypedFormControl(),
                    start: new UntypedFormControl(),
                    endDay: new UntypedFormControl(),
                    end: new UntypedFormControl(),
                })
            );
        } else {
            this.alert$.show({
                message: "Impossible d'ajouter plus de 7 horaires à cet écran.",
                duration: 5000,
            });
        }
    }

    /**
     * Retire le timer à l'index spécifié en paramètre
     * @param index Index du timer à enlever
     */
    removeTimer(index: number) {
        this.screenTimers.splice(index, 1);
        this.timersFormArray.removeAt(index);
    }

    /**
     * Récupère les timers sur MagicInfo et initialise screenTimer
     */
    getCurrentTimers_MagicInfo() {
        this.isTimersLoaded = false;

        this.remoteTvCmd$.getTimer(this.data.faceId).subscribe(
            (res: DeviceGetCurrentInfoResponse) => {
                if (res != null) {
                    if (res?.status === 'Success') {
                        this.screenTimers =
                            res.items.successList[0].timerConfTimerList;
                        //Création des Forms associés
                        this.screenTimersToFormControl();
                    } else {
                        //Erreur lors de la récupéarion des infos de la TV
                        this.dialogRef.close(false);
                        // this.alert$.show({
                        // 	message:
                        // 		"Erreur lors de la récupération des informartions de l'écran, vérifier que l'écran soit bien allumé puis réessayez",
                        // });
                        console.error(
                            res,
                            "Erreur lors de la récupération des informartions de l'écran, vérifier que l'écran soit bien allumé puis réessayez"
                        );
                    }
                } else {
                    //Aucun player lié à la face
                    this.alert$.show({
                        message:
                            "Impossible d'obtenir les informations de cet écran",
                        duration: 2000,
                    });

                    this.dialogRef.close(false);
                }
            },
            (err) => {
                console.error(err);
                this.isTimersLoaded = true;
            }
        );
    }

    /**
     * Récupère les timers sur la V2 et initialise
     */
    private getCurrentTimers_V2() {
        this.isTimersLoaded = false;

        this.faceTimeWork$.getFaceTimeWorks(this.data.faceId).subscribe({
            next:
                (faceTimeWorks: FaceTimeWork[]) => {
                    //convert FaceTimeWork to screenTimers
                    this.faceTimeWorkToScreenTimers(faceTimeWorks);

                    this.isTimersLoaded = true;
                }, error:
                (err) => {
                    console.error(err);
                    this.alert$.show({
                        message:
                            "Erreur lors de la récupération des horaires de l'écran, veuillez réessayer plus tard.",
                        duration: 5000,
                    });
                    this.isTimersLoaded = true;
                }
        }
        );
    }

    /**
     * Convert FaceTimeWork to screenTimers
     */
    private faceTimeWorkToScreenTimers(faceTimeWorks: FaceTimeWork[]) {
        let index: number = 1;
        faceTimeWorks.forEach((faceTimeWork: FaceTimeWork) => {
            let newTimer: TimerConfTimerList = new TimerConfTimerList();

            newTimer.timerSeq = index;

            this.setScreenTimerTime_Ftw(faceTimeWork, newTimer);

            // Day
            switch (faceTimeWork.dayOfWeek) {
                //Tous les jours
                case 127:
                    newTimer.timerRepeat = '1';
                    newTimer.timerOffRepeat = '1';
                    break;
                //Lundi au Vendredi
                case 31:
                    newTimer.timerRepeat = '2';
                    newTimer.timerOffRepeat = '2';
                    break;
                //Lundi au Samedi
                case 63:
                    newTimer.timerRepeat = '3';
                    newTimer.timerOffRepeat = '3';
                    break;
                //Week-end
                case 96:
                    newTimer.timerRepeat = '4';
                    newTimer.timerOffRepeat = '4';
                    break;
                //Aucun jour
                case 0:
                    newTimer.timerOnStatus = '0';
                    newTimer.timerOffStatus = '0';
                    break;
                //Jours spécifiques
                default: {
                    newTimer.timerRepeat = '5';
                    newTimer.timerOffRepeat = '5';

                    const indexTab: number[] = [1, 2, 4, 8, 16, 32, 64];
                    let initStr: string = '0000000';

                    //Si un seul jour
                    if (indexTab.includes(faceTimeWork.dayOfWeek)) {
                        initStr = this.replaceStrAt(
                            initStr,
                            indexTab.indexOf(faceTimeWork.dayOfWeek) + 1,
                            '1'
                        );
                        //Si plusieurs jours spécifiques
                    } else {
                        let days: number = faceTimeWork.dayOfWeek;
                        let allDays: number[] = [];
                        for (
                            let i: number = indexTab.length - 1;
                            i >= 0 && days !== 0;
                            i--
                        ) {
                            if (days - indexTab[i] >= 0) {
                                allDays.push(indexTab[i]);
                                days -= indexTab[i];
                            }
                        }

                        allDays.forEach((dayValue: number) => {
                            initStr = this.replaceStrAt(
                                initStr,
                                indexTab.indexOf(dayValue) + 1,
                                '1'
                            );
                        });
                    }

                    newTimer.timerManualWeekday = initStr;
                    newTimer.timerOffManualWeekday = initStr;
                    break;
                }
            }

            this.screenTimers.push(newTimer);
            index++;
        });

        this.screenTimersToFormControl();
    }

    /**
     * Enregistrer les horaires d'un FaceTimeWork dans le TimerconfTimerList
     * @param faceTimeWork FaceTimeWork d'où récupérer l'information
     * @param newTimer nouveau TimerConfTimerList où enregister l'information
     */
    private setScreenTimerTime_Ftw(
        faceTimeWork: FaceTimeWork,
        newTimer: TimerConfTimerList
    ) {
        // Timer On
        if (faceTimeWork.startLocation || faceTimeWork.startPlayer) {
            newTimer.timerOnStatus = '1';
            newTimer.timerOnH = faceTimeWork.startPlayer
                ? faceTimeWork.startPlayer.split(':')[0]
                : faceTimeWork.startLocation.split(':')[0];
            newTimer.timerOnM = faceTimeWork.startPlayer
                ? faceTimeWork.startPlayer.split(':')[1]
                : faceTimeWork.startLocation.split(':')[1];
        }

        // Timer Off
        if (faceTimeWork.endLocation || faceTimeWork.endPlayer) {
            newTimer.timerOffStatus = '1';
            newTimer.timerOffH = faceTimeWork.endPlayer
                ? faceTimeWork.endPlayer.split(':')[0]
                : faceTimeWork.endLocation.split(':')[0];
            newTimer.timerOffM = faceTimeWork.endPlayer
                ? faceTimeWork.endPlayer.split(':')[1]
                : faceTimeWork.endLocation.split(':')[1];
        }
    }

    /**
     * Sauvegarde et applique les horaires à l'écran
     * - Sauvegarde en BDD V2
     * - Application dans MagicInfo
     */
    validTimers() {
        //Get confirmation from user
        this.dialog
            .open(ConfirmationDialogComponent, {
                data: {
                    title: 'Sauvegarde des Horaires',
                    message:
                        'Etes-vous sûr de vouloir sauvegarder ces horaires ?',
                    okText: 'Valider ces horaires',
                    cancelText: 'Annuler',
                },
            })
            .afterClosed()
            .subscribe((res: { response: boolean }) => {
                if (res.response) {
                    //Save changes
                    this.isTimersLoaded = false;

                    //Côté V2
                    this.FormsToFaceTimeWorks();
                    this.setNewTimers_V2();
                } else {
                    return;
                }
            });
    }

    /**
     * convert tous les elements du formGroup dans screenTimers
     */
    private FormsToScreenTimers() {
        let index: number = 0;
        this.timersFormArray.controls.forEach((timerControl) => {
            //Start Day
            this.setStartDateScreentimers(timerControl.value.startDay, index);

            //Start Time
            this.setTimeScreenTimers(true, timerControl.value.start, index);

            //End Day - If simpleMode Start - else - EndDay
            this.setEndDateScreentimers(
                this.isDateSimpleMode
                    ? timerControl.value.startDay
                    : timerControl.value.endDay,
                index
            );

            //End Time
            this.setTimeScreenTimers(false, timerControl.value.end, index);

            //Timer Sequence
            this.screenTimers[index].timerSeq = index + 1;
            index++;
        });
    }

    /**
     * Transfère l'info des formControls dans une liste de `FaceTimeWork`
     */
    private FormsToFaceTimeWorks() {
        this.timersFormArray.controls.forEach((timerControl) => {

            if (
                timerControl.value.startDay != null &&
                timerControl.value.start != null &&
                timerControl.value.end != null
            ) {
                let newFtw: FaceTimeWork = {
                    dayOfWeek: timerControl.value.startDay.reduce(
                        (sum, currentValue) => sum + currentValue
                    ),
                    faceId: this.data.faceId,
                    id: 0,
                };

                //Start Time
                newFtw.startPlayer =
                    timerControl.value.start != null
                        ? timerControl.value.start + ':00'
                        : null;
                newFtw.startLocation =
                    timerControl.value.start != null
                        ? timerControl.value.start + ':00'
                        : null;

                //End Time
                newFtw.endPlayer =
                    timerControl.value.end != null
                        ? timerControl.value.end + ':00'
                        : null;
                newFtw.endLocation =
                    timerControl.value.end != null
                        ? timerControl.value.end + ':00'
                        : null;

                this.faceTimeWorks.push(newFtw);
            }
        });
    }

    /**
     * Affecte à la structure MagicInfo la valuer du formControl associé
     * @param startDay Valeur du control des jours `number[]`
     * @param index index de la ligne en question
     */
    private setStartDateScreentimers(startDay: number[], index: number) {
        if (startDay != null && startDay.length !== 0) {
            //Jour de début entré
            this.screenTimers[index].timerOnStatus = '1';

            if (startDay.includes(127)) {
                this.screenTimers[index].timerRepeat = '1';
            } else if (startDay.includes(96)) {
                this.screenTimers[index].timerRepeat = '4';
            } else {
                this.screenTimers[index].timerRepeat = '5';
                const indexTab: number[] = [1, 2, 4, 8, 16, 32, 64];
                let initStr: string = '0000000';
                startDay.forEach((dayValue: number) => {
                    initStr = this.replaceStrAt(
                        initStr,
                        indexTab.indexOf(dayValue) + 1,
                        '1'
                    );
                });

                this.screenTimers[index].timerManualWeekday = initStr;
            }
        } else {
            // Aucun jour de début : timer désactivé
            this.screenTimers[index].timerOnStatus = '0';
        }
    }

    /**
     * Défini l'heure du screenTimer depuis le formControl passé en paramètre
     * @param isStart boolean true si concerne l'heure de début false sinon
     * @param controlHour Heure du formControl source
     * @param index index du screenTimer
     */
    private setTimeScreenTimers(
        isStart: boolean,
        controlHour: string,
        index: number
    ) {
        if (isStart) {
            if (
                controlHour != null &&
                controlHour !== '' &&
                controlHour !== '0:0'
            ) {
                const splittedHour: string[] = controlHour.split(':');

                if (splittedHour[0] === '12') {
                    this.screenTimers[index].timerOnAmpm = '0';
                }

                this.screenTimers[index].timerOnH = splittedHour[0];
                this.screenTimers[index].timerOnM = splittedHour[1];
            } else {
                this.screenTimers[index].timerOnStatus = '0';
            }
        } else if (
            controlHour != null &&
            controlHour !== '' &&
            controlHour !== '0:0'
        ) {
            const splittedHour: string[] = controlHour.split(':');

            if (splittedHour[0] === '12') {
                this.screenTimers[index].timerOffAmpm = '0';
            }

            this.screenTimers[index].timerOffH = splittedHour[0];
            this.screenTimers[index].timerOffM = splittedHour[1];
        } else {
            this.screenTimers[index].timerOffStatus = '0';
        }
    }

    private setEndDateScreentimers(endDay: number[], index: number) {
        if (endDay != null && endDay.length !== 0) {
            //Jour de début entré
            this.screenTimers[index].timerOffStatus = '1';

            if (endDay.includes(127)) {
                this.screenTimers[index].timerOffRepeat = '1';
            } else if (endDay.includes(96)) {
                this.screenTimers[index].timerOffRepeat = '4';
            } else {
                this.screenTimers[index].timerOffRepeat = '5';
                const indexTab: number[] = [1, 2, 4, 8, 16, 32, 64];
                let initStr: string = '0000000';
                endDay.forEach((dayValue: number) => {
                    initStr = this.replaceStrAt(
                        initStr,
                        indexTab.indexOf(dayValue) + 1,
                        '1'
                    );
                });

                this.screenTimers[index].timerOffManualWeekday = initStr;
            }
        } else {
            // Aucun jour de début : timer désactivé
            this.screenTimers[index].timerOffStatus = '0';
        }
    }

    private replaceStrAt(str: string, index: number, char: string) {
        if (index > str.length - 1) index = 0;
        return str.substring(0, index) + char + str.substring(index + 1);
    }

    /**
     * Applique les horaires à la TV sur MagicInfo
     */
    setNewTimers_MagicInfo() {
        //Fill screenTimers to reset old ones
        let index: number = this.screenTimers.length;

        while (this.screenTimers.length !== 7) {
            index++;
            let newTimer: TimerConfTimerList = new TimerConfTimerList();
            newTimer.timerSeq = index;

            this.screenTimers.push(newTimer);
        }

        this.remoteTvCmd$
            .setTimer(this.data.faceId, this.screenTimers)
            .subscribe({
                next: () => {
                    this.alert$.show({
                        message: 'Horaires appliquées avec succès !',
                        duration: 3000,
                    });

                    this.screenTimers = this.screenTimers.filter(
                        (timer: TimerConfTimerList) => {
                            return (
                                timer.timerOnStatus === '1' ||
                                timer.timerOffStatus === '1'
                            );
                        }
                    );

                    //Clean les horaires ici
                    this.faceTimeWorks.forEach((timer) => {
                        timer.startPlayer = timer.startPlayer.slice(0, -3);
                        timer.endPlayer = timer.endPlayer.slice(0, -3);
                    });

                    this.dialogRef.close(this.faceTimeWorks);

                    this.isTimersLoaded = true;
                },
                error: (err) => {
                    console.error(err);
                    this.screenTimers = this.screenTimers.filter(
                        (timer: TimerConfTimerList) => {
                            return (
                                timer.timerOnStatus === '1' ||
                                timer.timerOffStatus === '1'
                            );
                        }
                    );
                    this.alert$.show({
                        message:
                            "Erreur lors de l'affectation des horaires à l'écran, veuillez réessayer plus tard.",
                        duration: 2000,
                    });
                    this.isTimersLoaded = true;
                },
            });
    }

    /**
     * Sauvegarde en BDD les nouvelles horaires
     */
    private setNewTimers_V2() {
        this.faceTimeWork$
            .setFaceTimeWorks(this.data.faceId, this.faceTimeWorks)
            .subscribe({
                next: () => {
                    //Coté MagicInfo
                    this.FormsToScreenTimers();
                    this.setNewTimers_MagicInfo();

                    // this.dialogRef.close(this.faceTimeWorks);

                    // this.isTimersLoaded = true;
                },
                error: (err) => {
                    console.error(err);
                    this.alert$.show({
                        message:
                            "Erreur lors de la sauvegarde des horaires de l'écran, veuillez réessayer plus tard.",
                        duration: 2000,
                    });

                    this.isTimersLoaded = true;
                },
            });
    }
}
